import {BRAND,platformDisplayName} from '../shared/brand.js';

export const DEFAULT_APP_NAME = BRAND.platform;
export const headerAppName=platformDisplayName;
// Compatibility exports keep existing learning and game imports unchanged.
export const isSummit = (appName: string): boolean => platformDisplayName(appName)===BRAND.platform;

export function BrandMark({ size = 32 }: { size?: number }) {
  return <img src={BRAND.mark} width={size} height={size} style={{objectFit:'contain'}} alt="" aria-hidden="true" decoding="async" />;
}
export const SummitMark=BrandMark;

export function BrandWordmark({ className = "inner-circle-wordmark", width = 210 }: { className?: string; width?: number }) {
  // The supplied guide reserves the tagline lockup for widths of at least 360 px.
  return <img className={className} src={width>=360?BRAND.wordmark:BRAND.headerWordmark} width={width} height={Math.round(width*256/1180)} alt={width>=360?`${BRAND.platform} ${BRAND.byline}`:BRAND.platform} decoding="async" />;
}
export const SummitWordmark=BrandWordmark;

export function MathBrand(){return <div className="math-brand"><BrandWordmark width={230}/></div>;}

// Keep caller props compatible; the supplied lockup contains its original lettering.
export function BrandLockup({ width = 210 }: { appName: string; width?: number; markSize?: number }) {
  return <span className="brand inner-circle-lockup" style={{width,maxWidth:'100%'}}><BrandWordmark width={width}/></span>;
}
export function BrandTagline({className=""}:{className?:string}){
  return <p className={`brand-tagline ${className}`.trim()}>{BRAND.tagline}</p>;
}
